const Director = 'Director'
const SalesExecutive = 'SalesExecutive'

const seller_comission_config_routes = [
  {
    path: '/seller_comission_configs',
    name: 'SellerComissionConfigs',
    meta: {
      auth: true,
      roles: [Director, SalesExecutive],
    },
    component: () =>
      import('@/_backoffice/_financial/components/seller_comission_configs/SellerComissionConfigsIndex.vue'),
  },
]

export default seller_comission_config_routes
